import { useState } from 'react';
import { TableRow, Typography, IconButton } from '@mui/material';

import { TableBodyCell } from '../table-cells/TableCells';

import Icon from '../Icon';
import UpdateAgentModal from './UpdateAgentModal';
import DeleteAgentModal from './DeleteAgentModal';

/**
 *
 * @param {string} uid
 * @param {string} device
 * @param {string} comment
 * @param {number} profile
 * @param {string} os
 * @param {string} lastSeen
 * @returns
 */

const formatDate = (date) => {
  const d = new Date(date);

  return Intl.DateTimeFormat('Us-us', {
    dateStyle: 'short',
    timeStyle: 'short',
  }).format(d);
};

const cellStyle = {
  width: '213px',
};

const buttonCellStyle = {
  width: '52px',
  p: 0,
};

const AgentsTableRow = ({
  uid,
  device,
  address,
  comment,
  profile,
  os,
  lastSeen,
}) => {
  const [isUpdateAgentModalShow, setUpdateAgentModalState] = useState(false);
  const [isDeleteAgentModalShow, setDeleteAgentModalState] = useState(false);

  const updateAgentModalStateHandler = () => {
    setUpdateAgentModalState((prevState) => !prevState);
  };

  const deleteAgentModalStateHandler = () => {
    setDeleteAgentModalState((prevState) => !prevState);
  };

  return (
    <TableRow
      sx={{
        '&:last-child td, &:last-child th': { border: 0 },
      }}
    >
      <TableBodyCell scope="row" sx={cellStyle}>
        {device}
        <Typography variant="tableCaption" component="div" color="text.light">
          {address}
        </Typography>
      </TableBodyCell>
      <TableBodyCell align="left" sx={cellStyle}>
        {profile}
      </TableBodyCell>
      <TableBodyCell align="left" sx={cellStyle}>
        {os}
      </TableBodyCell>
      <TableBodyCell align="left" sx={cellStyle}>
        {formatDate(lastSeen)}
      </TableBodyCell>
      <TableBodyCell scope="row" sx={cellStyle}>
        {comment}
      </TableBodyCell>
      <TableBodyCell sx={buttonCellStyle}>
        <IconButton onClick={updateAgentModalStateHandler}>
          <Icon id="edit" />
        </IconButton>
      </TableBodyCell>
      <TableBodyCell sx={buttonCellStyle}>
        <IconButton onClick={deleteAgentModalStateHandler}>
          <Icon id="delete" />
        </IconButton>
      </TableBodyCell>
      {isUpdateAgentModalShow ? (
        <UpdateAgentModal
          uid={uid}
          comment={comment}
          onClose={updateAgentModalStateHandler}
        />
      ) : null}
      {isDeleteAgentModalShow ? (
        <DeleteAgentModal
          uid={uid}
          agentName={device}
          onClose={deleteAgentModalStateHandler}
        />
      ) : null}
    </TableRow>
  );
};

export default AgentsTableRow;
